<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <footer class="site-footer" id="contact">
    <div>
      <img src="/images/logo.svg" alt="鑫谷程序员" />
      <p>真正以就业为导向的 IT 教育</p>
    </div>
    <div>
      <h4>快速导航</h4>
      <router-link to="/">首页</router-link>
      <router-link to="/about">公司简介</router-link>
      <router-link to="/learning-path">学习路线</router-link>
      <router-link to="/teachers">老师介绍</router-link>
    </div>
    <div class="footer-contact">
      <h4>联系我们</h4>
      <p>电话：13361037498</p>
      <p>邮箱：xinguit@126.com</p>
      <p>地址：北京市海淀区/山东省济南市</p>
    </div>
    <div>
      <h4>关注我们</h4>
      <div v-for="social in socials" :key="social.name" class="social">
        <img :src="social.logo" :alt="social.name" />
        <span>{{ social.name }}</span>
        <div><img :src="social.qr" :alt="social.name + '二维码'" /></div>
      </div>
    </div>
  </footer>
</template>
<script setup>
const socials = [
  { name: "微信", logo: "/images/ContactInfo/WeiXinLogo.png", qr: "/images/ContactInfo/WeiXin.jpg" },
  { name: "微信公众号", logo: "/images/ContactInfo/GongZhongHao.png", qr: "/images/ContactInfo/GongZhongHaoErWeiMa.jpg" },
  { name: "抖音", logo: "/images/ContactInfo/DouYinLogo.png", qr: "/images/ContactInfo/DouYin.jpg" },
  { name: "小红书", logo: "/images/ContactInfo/XiaoHongShuLogo.png", qr: "/images/ContactInfo/XiaoHongShu.jpg" },
  { name: "B站", logo: "/images/ContactInfo/BiliBiliLogo.png", qr: "/images/ContactInfo/BiliBili.jpg" },
];
</script>
